import styled from 'styled-components';
import logoBackground from '../../assets/logo-background.png';

export const Container = styled.div`
  padding-top: 150px;

  @media only screen and (max-width: 768px) {
    padding-top: 35px;
  }
`;

// <---- Start Get To Know ---->

export const GetToKnowContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

export const GetToKnowBackgroundContainer = styled.div`
  background: #fff url(${logoBackground}) no-repeat 50vw top;

  @media only screen and (max-width: 850px) {
    background: #fff url(${logoBackground}) no-repeat 65vw top;
    background-size: 50vw;
  }
`;

export const GetToKnowContent = styled.div`
  max-width: 340.5px;
  height: 900px;

  span {
    font-weight: 800;
    font-size: 30px;
    line-height: 45px;

    color: #000000;
  }

  h1 {
    font-weight: 800;
    font-size: 80px;
    line-height: 90px;

    color: #199ec6;
  }

  p {
    font-size: 18px;
    line-height: 27px;

    color: #272727;
    text-align: justify;
    margin-top: 25px;
  }

  @media only screen and (max-width: 768px) {
    height: auto;
    padding-bottom: 10px;

    span {
      font-size: 6vw;
      line-height: 14vw;
    }

    h1 {
      font-size: 17vw;
      line-height: 22vw;
    }

    p {
      font-size: min(5vw, 18px);
      line-height: min(8vw, 27px);
    }
  }
`;
// <---- End Get To Know ---->

// <---- Start Our Values ---->
export const OurValuesContainer = styled.div`
  padding-top: 50px;
  padding-bottom: 50px;
  padding: 20px;

  @media only screen and (max-width: 400px) {
    padding-bottom: 50px;
  }
`;

export const OurValuesContent = styled.div`
  margin: 0 auto;
  max-width: 800px;

  h1 {
    font-weight: 800;
    font-size: 80px;
    line-height: 135px;
    text-align: center;
    margin-bottom: 20px;

    color: #199ec6;
  }

  p {
    font-size: 18px;
    line-height: 27px;
    text-align: center;

    color: #272727;
  }

  @media only screen and (max-width: 768px) {
    h1 {
      font-size: min(9.4vw, 80px);
      line-height: min(10vw, 135px);
      margin-bottom: 20px;
    }

    p {
      text-align: justify;
      font-size: min(5vw, 18px);
      line-height: min(8vw, 27px);
    }
  }
`;
// <---- End Our Values ---->

// <---- Start Team ---->
export const TeamContainer = styled.div`
  padding-top: 50px;
  padding-bottom: 180px;

  @media only screen and (max-width: 768px) {
    padding-top: 0px;
    padding-bottom: 20px;
  }
`;

export const TeamContent = styled.div`
  margin: 0 auto;
  padding: 0px 20px;
  max-width: 1107px;

  h1 {
    text-align: center;
    font-weight: 800;
    font-size: 80px;
    line-height: 135px;
    text-align: center;

    color: #199ec6;

    margin-bottom: 50px;
  }

  @media only screen and (max-width: 400px) {
    h1 {
      font-size: min(9.4vw, 80px);
      line-height: min(10vw, 135px);

      margin-bottom: 20px;
    }

    p {
      text-align: justify;
      font-size: min(5vw, 18px);
      line-height: min(8vw, 27px);
    }
  }
`;

export const TeamList = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-around;
`;
// <---- End Team ---->
